// ===============================
// Vetiva Subscription UI
// - One-time stays default on load
// - Abo row gets a clean radio + interval dropdown
// - Dropdown defaults to "4 Wochen" WITHOUT selecting abo
// - If user changes dropdown, we switch to Abo and apply chosen selling plan
// - CRITICAL: Ensure selling_plan is submitted with Add-to-Cart via hidden input
// ===============================

(function () {
  function normalize(s) {
    return (s || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function getBlock() {
    return document.querySelector(".shopify_subscriptions_app_block");
  }

  function getProductForm(block) {
    // Find nearest product form that is actually submitted to cart
    return block.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  }

  function upsertHiddenSellingPlan(form, sellingPlanId) {
    if (!form) return;

    let input = form.querySelector('input[name="selling_plan"]');
    if (!sellingPlanId) {
      // remove/clear when one-time
      if (input) input.remove();
      return;
    }

    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = "selling_plan";
      form.appendChild(input);
    }
    input.value = String(sellingPlanId);
  }

  function getOneTimeRadio(block) {
    return block.querySelector('input[data-radio-type="one_time_purchase"]');
  }

  function getSellingPlanChecked(block) {
    return block.querySelector('input[data-radio-type="selling_plan"]:checked');
  }

  function isAnySellingPlanChecked(block) {
    return !!getSellingPlanChecked(block);
  }

  function clickSellingPlanById(block, sellingPlanId) {
    if (!sellingPlanId) return;
    const input = block.querySelector(
      `input[data-radio-type="selling_plan"][data-selling-plan-id="${sellingPlanId}"]`
    );
    if (input) input.click(); // triggers Shopify's internal listeners (when present)
  }

  function pickDefaultSellingPlanFromList(list) {
    const radios = Array.from(list.querySelectorAll('input[data-radio-type="selling_plan"]'));
    if (!radios.length) return null;

    const four = radios.find((r) =>
      normalize(r.closest("label")?.innerText).includes("4 wochen")
    );
    return four || radios[0];
  }

  function syncHiddenInput(block) {
    const form = getProductForm(block);
    const ot = getOneTimeRadio(block);
    const checked = getSellingPlanChecked(block);

    // If one-time is checked -> remove selling_plan hidden input
    if (ot && ot.checked) {
      upsertHiddenSellingPlan(form, null);
      return;
    }

    // If subscription plan is checked -> set selling_plan hidden input
    if (checked) {
      upsertHiddenSellingPlan(form, checked.dataset.sellingPlanId);
    }
  }

  function rebuildRowHead(row, block, mode) {
    // mode: "one_time" | "abo"
    const head = row.querySelector(".shopify_subscriptions_purchase_option_wrapper");
    if (!head) return;

    if (head.dataset.vetivaBuilt === "true") return;
    head.dataset.vetivaBuilt = "true";

    const price = head.querySelector(".shopify_subscriptions_in_widget_price");
    const title = head.querySelector("label");

    const left = document.createElement("div");
    left.className = "vetiva-left";

    let radioEl;

    if (mode === "one_time") {
      radioEl = row.querySelector('input[data-radio-type="one_time_purchase"]');
    } else {
      radioEl = document.createElement("input");
      radioEl.type = "radio";
      radioEl.name = "vetiva_purchase_option_ui";
      radioEl.className = "vetiva-abo-toggle";
    }

    if (title) title.style.cursor = "pointer";

    head.innerHTML = "";
    if (radioEl) left.appendChild(radioEl);
    if (title) left.appendChild(title);
    head.appendChild(left);
    if (price) head.appendChild(price);

    if (mode === "one_time") {
      title?.addEventListener("click", () => {
        const ot = getOneTimeRadio(block);
        if (ot) ot.click();
        setTimeout(() => syncHiddenInput(block), 0);
      });

      // whenever one-time radio changes, remove hidden input
      radioEl?.addEventListener("change", () => setTimeout(() => syncHiddenInput(block), 0));
      return;
    }

    // Abo mode
    const syncAboRadio = () => {
      const ot = getOneTimeRadio(block);
      const spChecked = isAnySellingPlanChecked(block);
      radioEl.checked = spChecked && !(ot && ot.checked);
    };

    function activateAboWithCurrentSelection() {
      const dropdown = row.querySelector(".vetiva-subscription-dropdown select");
      if (dropdown && dropdown.value) {
        clickSellingPlanById(block, dropdown.value);
      } else {
        const list = row.querySelector(".shopify_subscriptions_app_block_label_children");
        const def = list ? pickDefaultSellingPlanFromList(list) : null;
        if (def) def.click();
      }
      // ensure selling_plan hidden input is updated
      setTimeout(() => syncHiddenInput(block), 0);
    }

    radioEl.addEventListener("change", () => {
      activateAboWithCurrentSelection();
      syncAboRadio();
    });

    title?.addEventListener("click", () => {
      radioEl.checked = true;
      radioEl.dispatchEvent(new Event("change", { bubbles: true }));
    });

    block.addEventListener("change", () => {
      setTimeout(() => {
        syncAboRadio();
        syncHiddenInput(block);
      }, 0);
    });

    // initial sync
    syncAboRadio();
  }

  function buildDropdown(list, row, block) {
    if (list.dataset.vetivaConverted === "true") return;
    list.dataset.vetivaConverted = "true";

    const radios = Array.from(list.querySelectorAll('input[data-radio-type="selling_plan"]'));
    if (!radios.length) return;

    const defaultRadio = pickDefaultSellingPlanFromList(list);

    const wrap = document.createElement("div");
    wrap.className = "vetiva-subscription-dropdown";

    const select = document.createElement("select");

    radios.forEach((r) => {
      const label = r.closest("label");
      const txt = label ? label.innerText.replace(/\s+/g, " ").trim() : "Intervall";

      const opt = document.createElement("option");
      opt.value = r.dataset.sellingPlanId;
      opt.textContent = txt;

      if (r.checked) opt.selected = true;
      else if (!radios.some((x) => x.checked) && defaultRadio && r === defaultRadio) opt.selected = true;

      select.appendChild(opt);
    });

    // If user changes dropdown -> switch to Abo AND apply selling plan
    select.addEventListener("change", () => {
      const aboUiRadio = row.querySelector(".vetiva-abo-toggle");
      if (aboUiRadio) {
        aboUiRadio.checked = true;
        aboUiRadio.dispatchEvent(new Event("change", { bubbles: true }));
      } else {
        clickSellingPlanById(block, select.value);
        setTimeout(() => syncHiddenInput(block), 0);
      }
    });

    // Sync dropdown when Shopify changes checked plan
    const sync = () => {
      const checked = list.querySelector('input[data-radio-type="selling_plan"]:checked');
      if (checked) {
        const id = checked.dataset.sellingPlanId;
        if (id && select.value !== id) select.value = id;
        return;
      }
      if (defaultRadio) {
        const id = defaultRadio.dataset.sellingPlanId;
        if (id && select.value !== id) select.value = id;
      }
    };

    block.addEventListener("change", () => setTimeout(sync, 0));

    wrap.appendChild(select);

    // Hide original list but keep it for Shopify
    list.style.display = "none";
    list.parentNode.insertBefore(wrap, list);

    sync();
  }

  function init() {
    const block = getBlock();
    if (!block) return;

    const rows = Array.from(block.querySelectorAll(".shopify_subscriptions_app_block_label"));

    rows.forEach((row) => {
      const titleEl = row.querySelector(".shopify_subscriptions_purchase_option_wrapper > label");
      if (!titleEl) return;

      const t = normalize(titleEl.textContent);
      const isOneTime = t.includes("einmal");

      rebuildRowHead(row, block, isOneTime ? "one_time" : "abo");

      if (!isOneTime) {
        const list = row.querySelector(".shopify_subscriptions_app_block_label_children");
        if (list) buildDropdown(list, row, block);
      }
    });

    // Also ensure hidden input always reflects current state
    syncHiddenInput(block);

    // Final safety: on form submit, force-sync again
    const form = getProductForm(block);
    if (form && !form.dataset.vetivaSubBound) {
      form.dataset.vetivaSubBound = "true";
      form.addEventListener("submit", () => syncHiddenInput(block));
    }
  }

  document.addEventListener("DOMContentLoaded", init);

  const obs = new MutationObserver(() => init());
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();